export default __webpack_public_path__ + "static/media/mandet_image1.7c8f6d87.png";